module.exports = __webpack_public_path__ + "img/Aladdin_Baitfadhil.e17c12a8.png";